import React from "react"

import { NumberInput } from "@tenforce/product-fields"

import { updateField } from "../../slice"
import { useAppDispatch, useAppSelector } from "../../../../hooks"
import HTMLAndInternalLinkParser from "../common/HTMLAndInternalLinkParser"
import { Labels } from "../../../../util/Translations"
import { INumberField } from "../../index"
import { GlobalState } from "../../../../store"

export interface Props {
    field: INumberField
}

export const NumberField = ({ field }: Props): JSX.Element => {
    const dispatch = useAppDispatch()
    const { isLoading } = useAppSelector((state: GlobalState) => state.fields)

    const {
        position: _position,
        odataType: _odataType,
        isAutoCompleteEnabled,
        itemId,
        value,
        maxNumberOfIntegerDigits,
        maxNumberOfDecimalDigits,
        ...fieldProps
    } = field

    const { ClickHereToEdit, RequiredFieldErrorMessage } = Labels

    return (
        <NumberInput
            {...fieldProps}
            isLoading={isLoading}
            description={
                <HTMLAndInternalLinkParser
                    content={(field?.description as string) ?? ""}
                />
            }
            value={value}
            maxWholeDigits={maxNumberOfIntegerDigits}
            maxDecimalDigits={maxNumberOfDecimalDigits}
            placeholder={ClickHereToEdit}
            mandatoryErrorText={RequiredFieldErrorMessage}
            onSave={(newValue: number): void => {
                if (newValue === value) {
                    return
                }
                dispatch(
                    updateField({
                        field,
                        newValue,
                    }),
                )
            }}
        />
    )
}

export default NumberField
